import { BYO_ADD_SELECTION, BYO_REMOVE_SELECTION, BYO_SLIP_ADD_PRICE_TO_STORE, BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE, BYO_SLIP_ADD_SELECTION_TO_STORE, BYO_SLIP_REMOVE_PRICE_FROM_STORE, BYO_SLIP_REMOVE_SELECTION_FROM_STORE, BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE, BYO_ODDS_FORMAT, BYO_SLIP_CLEAR_ALL, BYO_SLIP_EXPANDED, BYO_ADD_TO_BETSLIP, BYO_PROCESSING_TO_BETSLIP, BYO_PROCESS_SELECTION, BYO_EDIT_SELECTIONS, BYO_SET_EDIT_ID, } from '../constants';
export const editSelections = (payload) => ({
    type: BYO_EDIT_SELECTIONS,
    payload,
});
export const expandSlip = (isExpanded) => ({
    type: BYO_SLIP_EXPANDED,
    payload: isExpanded
});
export const addToSlip = (selection) => ({
    type: BYO_ADD_SELECTION,
    payload: selection
});
export const processSelection = (selection) => ({
    type: BYO_PROCESS_SELECTION,
    payload: selection
});
export const addToBetslip = () => ({
    type: BYO_ADD_TO_BETSLIP,
});
export const processingSelectionToBetslip = (isAddingToBetslip) => ({
    type: BYO_PROCESSING_TO_BETSLIP,
    payload: isAddingToBetslip
});
export const removeFromSlip = (selection) => ({
    type: BYO_REMOVE_SELECTION,
    payload: selection
});
export const clearSlip = () => ({
    type: BYO_SLIP_CLEAR_ALL
});
export const addSelectionToStore = (selection) => ({
    type: BYO_SLIP_ADD_SELECTION_TO_STORE,
    payload: selection
});
export const addSelectionToProcessingQueue = (selection) => ({
    type: BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE,
    payload: selection
});
export const removeSelectionFromStore = (selection) => ({
    type: BYO_SLIP_REMOVE_SELECTION_FROM_STORE,
    payload: selection
});
export const removeSelectionFromProcessingQueue = (selection) => ({
    type: BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE,
    payload: selection
});
export const addPrice = (selectionInfo) => ({
    type: BYO_SLIP_ADD_PRICE_TO_STORE,
    payload: selectionInfo
});
export const setEditID = (id) => ({
    type: BYO_SET_EDIT_ID,
    payload: id
});
export const removePrice = () => ({
    type: BYO_SLIP_REMOVE_PRICE_FROM_STORE
});
export const addOddsFormatToStore = (oddsFormat) => ({
    type: BYO_ODDS_FORMAT,
    payload: oddsFormat
});
